// Currency options + money formatting for global deals.
export const CURRENCIES = [
  { code: "USD", symbol: "$", label: "US Dollar (USD)" },
  { code: "EUR", symbol: "€", label: "Euro (EUR)" },
  { code: "GBP", symbol: "£", label: "British Pound (GBP)" },
  { code: "CAD", symbol: "CA$", label: "Canadian Dollar (CAD)" },
  { code: "AUD", symbol: "A$", label: "Australian Dollar (AUD)" },
  { code: "INR", symbol: "₹", label: "Indian Rupee (INR)" },
  { code: "AED", symbol: "د.إ", label: "UAE Dirham (AED)" },
  { code: "NGN", symbol: "₦", label: "Nigerian Naira (NGN)" },
  { code: "ZAR", symbol: "R", label: "South African Rand (ZAR)" },
  { code: "TTD", symbol: "TT$", label: "Trinidad & Tobago Dollar (TTD)" },
  { code: "JMD", symbol: "J$", label: "Jamaican Dollar (JMD)" },
  { code: "BBD", symbol: "Bds$", label: "Barbadian Dollar (BBD)" },
  { code: "GYD", symbol: "G$", label: "Guyanese Dollar (GYD)" },
  { code: "XCD", symbol: "EC$", label: "East Caribbean Dollar (XCD)" },
  { code: "BSD", symbol: "B$", label: "Bahamian Dollar (BSD)" },
  { code: "BZD", symbol: "BZ$", label: "Belize Dollar (BZD)" },
  { code: "BMD", symbol: "BD$", label: "Bermudian Dollar (BMD)" },
  { code: "KYD", symbol: "CI$", label: "Cayman Islands Dollar (KYD)" },
  { code: "DOP", symbol: "RD$", label: "Dominican Peso (DOP)" },
  { code: "HTG", symbol: "G", label: "Haitian Gourde (HTG)" },
  { code: "SRD", symbol: "SRD ", label: "Surinamese Dollar (SRD)" },
  { code: "AWG", symbol: "Afl.", label: "Aruban Florin (AWG)" },
  { code: "ANG", symbol: "ƒ", label: "Netherlands Antillean Guilder (ANG)" },
  { code: "MXN", symbol: "MX$", label: "Mexican Peso (MXN)" },
  { code: "BRL", symbol: "R$", label: "Brazilian Real (BRL)" },
  { code: "COP", symbol: "COL$", label: "Colombian Peso (COP)" },
  { code: "CLP", symbol: "CLP$", label: "Chilean Peso (CLP)" },
  { code: "PEN", symbol: "S/", label: "Peruvian Sol (PEN)" },
  { code: "ARS", symbol: "AR$", label: "Argentine Peso (ARS)" },
  { code: "NZD", symbol: "NZ$", label: "New Zealand Dollar (NZD)" },
  { code: "CHF", symbol: "CHF ", label: "Swiss Franc (CHF)" },
  { code: "SEK", symbol: "kr ", label: "Swedish Krona (SEK)" },
  { code: "NOK", symbol: "kr ", label: "Norwegian Krone (NOK)" },
  { code: "DKK", symbol: "kr ", label: "Danish Krone (DKK)" },
  { code: "PLN", symbol: "zł ", label: "Polish Zloty (PLN)" },
  { code: "TRY", symbol: "₺", label: "Turkish Lira (TRY)" },
  { code: "JPY", symbol: "¥", label: "Japanese Yen (JPY)" },
  { code: "CNY", symbol: "CN¥", label: "Chinese Yuan (CNY)" },
  { code: "HKD", symbol: "HK$", label: "Hong Kong Dollar (HKD)" },
  { code: "KRW", symbol: "₩", label: "South Korean Won (KRW)" },
  { code: "SGD", symbol: "S$", label: "Singapore Dollar (SGD)" },
  { code: "MYR", symbol: "RM", label: "Malaysian Ringgit (MYR)" },
  { code: "THB", symbol: "฿", label: "Thai Baht (THB)" },
  { code: "PHP", symbol: "₱", label: "Philippine Peso (PHP)" },
  { code: "IDR", symbol: "Rp", label: "Indonesian Rupiah (IDR)" },
  { code: "VND", symbol: "₫", label: "Vietnamese Dong (VND)" },
  { code: "SAR", symbol: "SR ", label: "Saudi Riyal (SAR)" },
  { code: "QAR", symbol: "QR ", label: "Qatari Riyal (QAR)" },
  { code: "KES", symbol: "KSh ", label: "Kenyan Shilling (KES)" },
  { code: "GHS", symbol: "GH₵", label: "Ghanaian Cedi (GHS)" },
  { code: "EGP", symbol: "E£", label: "Egyptian Pound (EGP)" },
  { code: "MAD", symbol: "MAD ", label: "Moroccan Dirham (MAD)" },
];

const MAP = Object.fromEntries(CURRENCIES.map((c) => [c.code, c]));

const COUNTRY_CURRENCY = {
  "Trinidad & Tobago": "TTD", "Trinidad and Tobago": "TTD", "Jamaica": "JMD", "Barbados": "BBD",
  "Guyana": "GYD", "Grenada": "XCD", "Saint Lucia": "XCD", "St Lucia": "XCD",
  "Antigua and Barbuda": "XCD", "Dominica": "XCD", "St Kitts and Nevis": "XCD",
  "Saint Kitts and Nevis": "XCD", "St Vincent and the Grenadines": "XCD",
  "Saint Vincent and the Grenadines": "XCD", "Anguilla": "XCD", "Montserrat": "XCD",
  "The Bahamas": "BSD", "Bahamas": "BSD", "Belize": "BZD", "Bermuda": "BMD",
  "Cayman Islands": "KYD", "Dominican Republic": "DOP", "Haiti": "HTG", "Suriname": "SRD",
  "Aruba": "AWG", "Curaçao": "ANG", "Curacao": "ANG", "Puerto Rico": "USD",
  "United States": "USD", "USA": "USD", "US": "USD", "Panama": "USD",
  "Mexico": "MXN", "Brazil": "BRL", "Colombia": "COP", "Chile": "CLP", "Peru": "PEN",
  "Argentina": "ARS", "New Zealand": "NZD", "Switzerland": "CHF", "Sweden": "SEK",
  "Norway": "NOK", "Denmark": "DKK", "Poland": "PLN", "Turkey": "TRY", "Japan": "JPY",
  "China": "CNY", "Hong Kong": "HKD", "South Korea": "KRW", "Singapore": "SGD",
  "Malaysia": "MYR", "Thailand": "THB", "Philippines": "PHP", "Indonesia": "IDR",
  "Vietnam": "VND", "Saudi Arabia": "SAR", "Qatar": "QAR", "Kenya": "KES",
  "Ghana": "GHS", "Egypt": "EGP", "Morocco": "MAD",
  "UK": "GBP", "United Kingdom": "GBP", "Canada": "CAD", "Australia": "AUD",
  "India": "INR", "United Arab Emirates": "AED", "UAE": "AED", "Nigeria": "NGN", "South Africa": "ZAR",
  "France": "EUR", "Germany": "EUR", "Spain": "EUR", "Italy": "EUR", "Portugal": "EUR",
  "Netherlands": "EUR", "Belgium": "EUR", "Ireland": "EUR", "Austria": "EUR", "Greece": "EUR",
  "Finland": "EUR", "Luxembourg": "EUR", "Slovakia": "EUR", "Slovenia": "EUR", "Estonia": "EUR",
  "Latvia": "EUR", "Lithuania": "EUR", "Cyprus": "EUR", "Malta": "EUR", "Croatia": "EUR",
};

export const symbolFor = (code) => (MAP[code]?.symbol) || (code ? `${code} ` : "$");

export const defaultCurrencyForCountry = (country) => COUNTRY_CURRENCY[country] || "USD";

// Best-effort home currency from the visitor's browser locale (only returns supported codes).
const REGION_CURRENCY = {
  US: "USD", GB: "GBP", CA: "CAD", AU: "AUD", NZ: "NZD", IN: "INR", AE: "AED",
  NG: "NGN", ZA: "ZAR", TT: "TTD", JM: "JMD", BB: "BBD", GY: "GYD",
  BS: "BSD", BZ: "BZD", BM: "BMD", KY: "KYD", DO: "DOP", HT: "HTG", SR: "SRD",
  AW: "AWG", CW: "ANG", LC: "XCD", GD: "XCD", AG: "XCD", DM: "XCD", KN: "XCD", VC: "XCD",
  MX: "MXN", BR: "BRL", CO: "COP", CL: "CLP", PE: "PEN", AR: "ARS",
  CH: "CHF", SE: "SEK", NO: "NOK", DK: "DKK", PL: "PLN", TR: "TRY", JP: "JPY",
  CN: "CNY", HK: "HKD", KR: "KRW", SG: "SGD", MY: "MYR", TH: "THB", PH: "PHP",
  ID: "IDR", VN: "VND", SA: "SAR", QA: "QAR", KE: "KES", GH: "GHS", EG: "EGP", MA: "MAD",
  DE: "EUR", FR: "EUR", ES: "EUR", IT: "EUR", NL: "EUR", IE: "EUR", PT: "EUR",
  AT: "EUR", BE: "EUR", FI: "EUR", GR: "EUR", LU: "EUR", SK: "EUR", SI: "EUR",
  EE: "EUR", LV: "EUR", LT: "EUR", CY: "EUR", MT: "EUR",
};

export const detectHomeCurrency = () => {
  try {
    const lang = (typeof navigator !== "undefined" && (navigator.language || (navigator.languages || [])[0])) || "en-US";
    let region = "";
    try { region = new Intl.Locale(lang).region || ""; } catch { region = ""; }
    if (!region && lang.includes("-")) region = lang.split("-").pop();
    region = (region || "").toUpperCase();
    const code = REGION_CURRENCY[region];
    return MAP[code] ? code : "USD";
  } catch {
    return "USD";
  }
};

export const money = (amount, code) => {
  if (amount == null) return "";
  return `${symbolFor(code)}${Number(amount).toFixed(2)}`;
};
